import React, { useState } from 'react';
import { CartTableRow } from './CartTableRow';
import { CartHeadProps, CartLineItem, CartResponse } from '../../models/Cart';
import useShopifyCart from '../../hooks/shopify/useShopifyCart';
import { BasicTable } from '../shared/BasicTable/BasicTable';
import { Box, styled } from '@mui/material';
import { CART_HEAD_CELLS } from '../../utils/constans/tableHeads/cartTableHead';
import { CartSummaries } from './CartSummaries';

const StyledCartWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    gap: '15px',
    [theme.breakpoints.down('lg')]: {
        flexDirection: 'column',
    },
}));

export const CartPage = (props: { items: CartResponse }) => {
    const { items } = props;
    const [cart, setCart] = useState(items);
    const shopifyCart = useShopifyCart();

    const tableHeadSettings = {
        translateNs: 'cart',
        translatePrefix: 'CART.TABLE_HEAD',
        selectable: false,
        headContent: CART_HEAD_CELLS,
    };

    const getProducts = (): CartLineItem[] => {
        return cart.lines.edges.map((elem) => {
            return elem.node;
        });
    };

    const updateCart = (props) => {
        if (props.remove) {
            shopifyCart.removeCartItem([props.rowID]).then((resp) => {
                setCart(resp.cartLinesRemove.cart);
            });
        } else {
            shopifyCart
                .updateCartItem([
                    {
                        id: props.rowID,
                        quantity: props.qty,
                    },
                ])
                .then((resp) => {
                    setCart(resp.cartLinesUpdate.cart);
                });
        }
    };

    return (
        <>
            <StyledCartWrapper>
                <Box sx={{ flex: '70% 0 0' }}>
                    <BasicTable<CartLineItem, CartHeadProps>
                        fullList={getProducts()}
                        tableHeadSettings={tableHeadSettings}
                        component={CartTableRow}
                        handleChange={updateCart}
                    />
                </Box>
                <Box sx={{ flex: '30% 0 0' }}>
                    <CartSummaries cart={cart} />
                </Box>
            </StyledCartWrapper>
        </>
    );
};
